export { default as TotalStatusIcon } from './total-status-icon'



// WEBPACK FOOTER //
// ./src/components/molecules/total-status-icon/index.ts